import {Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {NzModalService, NzMessageService} from 'ng-zorro-antd';

@Injectable({
  providedIn: 'root'
})
export class ModalConfigService {

  constructor(
    private modalService: NzModalService,
    private message: NzMessageService,
    private translateService: TranslateService
  ) {
  }


  /**
   * 基础模态框
   * @param options.width // 宽
   * @param options.title //
   * @param options.content //
   * @param options.okText // 确认按钮文案
   * @param options.cancelText // 取消按钮文案
   * @param options.ok // 确认回调
   * @param options.cancel // 取消回调
   * @param options.maskClosable // 点击蒙层是否关闭
   */
  createCancel(
    options: {
      width?: string,
      title: string,
      content?: string,
      okText?: string
      cancelText?: string
      ok?: any,
      cancel?: any,
      maskClosable?: boolean
    }): void {
    this.modalService.create({
      nzWidth: options.width || '360',
      nzTitle: `${options.title || ''}`,
      nzContent: `${options.content ? options.content : ''}`,
      nzOkText: options.okText ? options.okText : '确定',
      nzCancelText: options.cancelText || options.cancelText === null ? options.cancelText : '取消',
      nzOnOk: options.ok ? () => options.ok() : () => {
      },
      nzOnCancel: options.cancel ? () => options.cancel() : () => {
      },
      nzMaskClosable: options.maskClosable === void 0 ? true : false,
    });
  }

  /**
   * 确认
   * primary 效果
   * @param options.title //
   * @param options.content //
   * @param options.okText // 确认按钮文案
   * @param options.cancelText // 取消按钮文案
   * @param options.ok // 确认回调
   * @param options.cancel // 取消回调
   * @param options.maskClosable // 点击蒙层是否关闭
   */
  infoConfirm(
    options: {
      title: string,
      content?: string,
      okText?: string
      cancelText?: string
      ok?: any,
      cancel?: any,
      maskClosable?: boolean
    }): void {
    this.modalService.confirm({
      nzTitle: `${options.title || ''}`,
      nzContent: `<b style="color: red;"> ${options.content ? options.content : ''}</b>`,
      nzOkText: options.okText ? options.okText : '确定',
      nzCancelText: options.cancelText || options.cancelText === null ? options.cancelText : '取消',
      nzOnOk: options.ok ? () => options.ok() : () => {
      },
      nzOnCancel: options.cancel ? () => options.cancel() : () => {
      },
      nzOkType: 'primary',
      nzMaskClosable: options.maskClosable === void 0 ? true : false,
    });
  }

  /**
   * 错误
   * @param options.title //
   * @param options.content //
   * @param options.okText // 确认按钮文案
   * @param options.cancelText // 取消按钮文案
   * @param options.ok // 确认回调
   * @param options.cancel // 取消回调
   * @param options.maskClosable // 点击蒙层是否关闭
   */
  errConfirm(
    options: {
      title: string,
      content?: string,
      okText?: string
      cancelText?: string
      ok?: any,
      cancel?: any,
      maskClosable?: boolean
    }): void {
    this.modalService.confirm({
      nzTitle: `${options.title || ''}`,
      nzContent: `<b style="color: red;"> ${options.content ? options.content : ''}</b>`,
      nzOkText: options.okText ? options.okText : '确定',
      nzCancelText: options.cancelText || options.cancelText === null ? options.cancelText : '取消',
      nzOnOk: options.ok ? () => options.ok() : () => {
      },
      nzOnCancel: options.cancel ? () => options.cancel() : () => {
      },
      nzMaskClosable: options.maskClosable === void 0 ? true : false,
    });
  }

  /**
   * 提示
   * @param options.title //
   * @param options.content //
   * @param options.okText // 确认按钮文案
   * @param options.cancelText // 取消按钮文案
   * @param options.ok // 确认回调
   * @param options.cancel // 取消回调
   * @param options.maskClosable // 点击蒙层是否关闭
   */
  info(options: {
    title: string,
    content?: string,
    okText?: string
    cancelText?: string
    ok?: any,
    cancel?: any,
    maskClosable?: boolean
  }): void {
    this.modalService.info({
      nzTitle: `${options.title || ''}`,
      nzContent: `${options.content ? options.content : ''}`,
      nzOkText: options.okText ? options.okText : '确定',
      nzCancelText: options.cancelText || options.cancelText === null ? options.cancelText : '取消',
      nzOnOk: options.ok ? () => options.ok() : () => {
      },
      nzOnCancel: options.cancel ? () => options.cancel() : () => {
      },
      nzMaskClosable: options.maskClosable === void 0 ? true : false,
    });
  }

  /**
   * 成功
   * @param options.title //
   * @param options.content //
   * @param options.okText // 确认按钮文案
   * @param options.cancelText // 取消按钮文案
   * @param options.ok // 确认回调
   * @param options.cancel // 取消回调
   * @param options.maskClosable // 点击蒙层是否关闭
   */
  success(options: {
    title: string,
    content?: string,
    okText?: string
    cancelText?: string
    ok?: any,
    cancel?: any,
    maskClosable?: boolean
  }): void {
    this.modalService.success({
      nzTitle: `${options.title || ''}`,
      nzContent: `${options.content ? options.content : ''}`,
      nzOkText: options.okText ? options.okText : '确定',
      nzCancelText: options.cancelText || options.cancelText === null ? options.cancelText : '取消',
      nzOnOk: options.ok ? () => options.ok() : () => {
      },
      nzOnCancel: options.cancel ? () => options.cancel() : () => {
      },
      nzMaskClosable: options.maskClosable === void 0 ? true : false,
    });
  }

  /**
   * 错误
   * @param options.title //
   * @param options.content //
   * @param options.okText // 确认按钮文案
   * @param options.cancelText // 取消按钮文案
   * @param options.ok // 确认回调
   * @param options.cancel // 取消回调
   * @param options.maskClosable // 点击蒙层是否关闭
   */
  error(
    options: {
      title: string,
      content?: string,
      okText?: string
      cancelText?: string
      ok?: any,
      cancel?: any,
      maskClosable?: boolean
    }): void {
    this.modalService.error({
      nzTitle: `${options.title || ''}`,
      nzContent: `${options.content ? options.content : ''}`,
      nzOkText: options.okText ? options.okText : '确定',
      nzCancelText: options.cancelText || options.cancelText === null ? options.cancelText : '取消',
      nzOnOk: options.ok ? () => options.ok() : () => {
      },
      nzOnCancel: options.cancel ? () => options.cancel() : () => {
      },
      nzMaskClosable: options.maskClosable === void 0 ? true : false,
    });
  }

  /**
   * 警告
   * @param options.title //
   * @param options.content //
   * @param options.okText // 确认按钮文案
   * @param options.cancelText // 取消按钮文案
   * @param options.ok // 确认回调
   * @param options.cancel // 取消回调
   * @param options.maskClosable // 点击蒙层是否关闭
   */
  warning(options: {
    title: string,
    content?: string,
    okText?: string
    cancelText?: string
    ok?: any,
    cancel?: any,
    maskClosable?: boolean
  }): void {
    this.modalService.warning({
      nzTitle: `${options.title || ''}`,
      nzContent: `${options.content ? options.content : ''}`,
      nzOkText: options.okText ? options.okText : '确定',
      nzCancelText: options.cancelText || options.cancelText === null ? options.cancelText : '取消',
      nzOnOk: options.ok ? () => options.ok() : () => {
      },
      nzOnCancel: options.cancel ? () => options.cancel() : () => {
      },
      nzMaskClosable: options.maskClosable === void 0 ? true : false,
    });
  }


  /**
   *
   * @param message  错误提示框
   */
  errMsg(message: string): void {
    this.translateService.get(message).subscribe((res:string)=>{
      this.message.error(res);
    })
  }

  /**
   *
   * @param message  信息提示框
   */
  infoMsg(message: string): void {
    this.translateService.get(message).subscribe((res:string)=>{
      this.message.info(res);
    })
  }

  /**
   *
   * @param message  注意提示框
   */
  warningMsg(message: string): void {
    this.translateService.get(message).subscribe((res:string)=>{
      this.message.warning(res);
    })
  }

  /*
  *
  * @param message  成功提示框
  */
  successMsg(message: string): void {
    this.translateService.get(message).subscribe((res:string)=>{
      this.message.success(res, {nzDuration: 1000});
    })
  }

  /**
   *
   * @param message  加载提示框
   */
  loadingMsg(message: string): void {
    this.translateService.get(message).subscribe((res:string)=>{
      this.message.loading(res ? res : '');
    })
  }
}
